import Vue from 'vue'
function setKeep(o,name){		
	let arr = [];
	let hasComp = false;
	if(o){
		arr = o.split(",");
		arr.forEach(function(v,i){
			if(v==name){
				hasComp = true;//已经加入
			}
		});
	};
	if(!hasComp){
		arr.push(name);
	}		
	return arr.join(",");
};
function removeKeep(o,name,panes){	
	//清除缓存		
	let arr = o.split(",");
	let hasName = true;		
	panes.forEach(function(v,i){
		if(v && v.name == name){//还有其他切换选择项
			hasName = false;
		}
	});
	if(hasName){		
		let index = arr.indexOf(name);
		if(index >-1){
			arr.splice(index,1);
		}
	}		
	return arr.join(",")
};
const state = {
	ExKeepComps:"",//不缓存
	KeepComps:"",
	panes:[]
}
  // getters
const getters = {
	getState:state => {
		return state;
	},
	getKeepComps: state => {			
        return state.KeepComps;
    },
    getExKeepComps: state => {				
        return state.ExKeepComps;
    },
    getPanes: state => {    	
    	return state.panes;
    }
}  // actions
const actions = {   //异步
    getKeepComps({commit},arg) {
    	return	commit ('getKeepComps',arg);
	},
	delKeepComps({commit},arg) {  		
    	return	commit ('delKeepComps',arg);
	},
	addPanes({commit},item) { 
		return	commit ("addPanes",item);
	},
	delPanes({commit},removeId) { 
		return	commit ("delPanes",removeId);
	}
}// mutations
const mutations = {
    getKeepComps (state, arg) {//添加缓存列表   
    	Vue.set(state, "KeepComps",setKeep(state.KeepComps,arg.name)); 
    	Vue.set(state, "ExKeepComps",removeKeep(state.ExKeepComps,arg.name,arg.panes)); 
    	//设置panes
    	Vue.set(state,"panes",arg.panes);    	
    },
    delKeepComps (state, arg) {//删除缓存列表    	
    	Vue.set(state, "ExKeepComps",setKeep(state.ExKeepComps,arg.name)); 
    	Vue.set(state, "KeepComps",removeKeep(state.KeepComps,arg.name,arg.panes)); 
    },
    addPanes (state,item){  
    	if(item && item.key){
    		if(item.key=="login"){
    			return;
    		}
	    	let isAdd = true;
	    	state.panes.forEach(function(v,i){
	    		if(v.key == item.key){
	    			isAdd = false;
	    		}
	    	});
	    	if(isAdd){    		
	    		if(item.title == '首页'){//首页
		    		item.closable=false;
		    		state.panes.unshift(item);
		    	}else{
		    		state.panes.push(item);
		    	}    		
	    	}
    	}
    },
    delPanes (state,removeId){
    	state.panes.splice(removeId,1);
    }
}
  
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}




// WEBPACK FOOTER //
// ./src/store/modules/clearCache.js